import { fxGetUnreadCount, $unreadCount } from './unread-count.model';

$unreadCount.on(fxGetUnreadCount.done, (_, { result }) => result.count);
